import * as yup from 'yup';
import { DOB_ERROR_MSG } from '../constants/dateOfBirth';
import { isMinor } from '@/lib/utils/utils';

export function dateOfBirthValidation(allowYearOnly: boolean, customMessages = DOB_ERROR_MSG) {
  const messages = customMessages;

  return {
    dateOfBirth: yup.string().test({
      name: 'validateDate',
      test(value, ctx) {
        if (allowYearOnly) {
          const year = Number(value);
          const currentYear = new Date().getFullYear();
          if (!value?.trim() || !/^\d{4}$/.test(value)) {
            return ctx.createError({ message: messages.only_year_invalid });
          }
          if (year > currentYear) {
            return ctx.createError({ message: messages.year_future });
          }
          return true;
        }

        // Single-field MMDDYYYY validation
        if (!value?.trim()) {
          return ctx.createError({ message: messages.required });
        }

        // Must match MMDDYYYY pattern
        if (!/^(?:0[1-9]|1[0-2])(?:0[1-9]|[12]\d|3[01])(?:19|20)\d{2}$/.test(value)) {
          return ctx.createError({ message: messages.date_invalid });
        }

        const month = Number(value.substring(0, 2));
        const day = Number(value.substring(2, 4));
        const year = Number(value.substring(4, 8));

        // Validate days in month (including leap year)
        const daysInMonth = [31, 28, 31, 30, 31, 30, 31, 31, 30, 31, 30, 31];
        if (month === 2 && ((year % 4 === 0 && year % 100 !== 0) || year % 400 === 0)) {
          if (day > 29) {
            return ctx.createError({ message: messages.date_invalid });
          }
        } else if (day > daysInMonth[month - 1]) {
          return ctx.createError({ message: messages.date_invalid });
        }

        // Check for future date
        const enteredDate = new Date(year, month - 1, day);
        if (enteredDate > new Date()) {
          return ctx.createError({ message: messages.future });
        }

        // Minor validation: check if under 18
        const flow = sessionStorage?.getItem('lookupFlow');
        const date = `${value.substring(0, 2)}/${value.substring(2, 4)}/${value.substring(4, 8)}`;
        if (isMinor(date) && flow && ['PHARMACY', 'h4l_onboarding', 'H4L', 'rx_merge', 'healthy_caregiver'].indexOf(flow) !== -1) {
          return ctx.createError({ message: messages.underage, type: 'minor' });
        }

        return true;
      }
    })
  };
}
